import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, Pencil, Plus, Search } from "lucide-react";
import { errMsg } from "@/lib/api";
import { ConfirmDelete } from "@/components/admin/AdminUi";
import { cassa } from "./cassaApi";
import { ClientForm } from "./ClientForm";
import { ClientDetail } from "./ClientDetail";

export function useClients(q) {
  const [list, setList] = useState([]);
  const load = () => cassa.get("/clients", { params: { q } }).then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  return [list, load];
}

export function ClientsTab() {
  const [q, setQ] = useState("");
  const [list, load] = useClients(q);
  const [edit, setEdit] = useState(null);
  const [view, setView] = useState(null);
  const del = async (c) => { try { await cassa.delete(`/clients/${c.id}`); toast.success("Cliente eliminato"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-4" data-testid="cassa-clients-tab">
      <div className="flex flex-wrap gap-2 justify-between">
        <div className="relative flex-1 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input data-testid="cassa-clients-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome, P.IVA, codice fiscale, città" className="w-full h-11 pl-9 pr-3 rounded-md border bg-white text-sm focus:outline-none focus:ring-2 focus:ring-brand-yellow" />
        </div>
        <button data-testid="cassa-client-new-btn" onClick={() => setEdit({})} className="press h-11 px-4 rounded-md bg-brand-yellow text-brand-navy font-bold flex items-center gap-2"><Plus className="w-4 h-4" /> Nuovo cliente</button>
      </div>
      <p className="text-xs text-slate-500">Anagrafiche della cassa, separate dai clienti registrati sul sito. Sono salvate crittografate.</p>
      <div className="rounded-xl border bg-white divide-y">
        {list.map((c) => (
          <div key={c.id} className="px-4 py-3 flex flex-wrap items-center gap-3" data-testid={`cassa-client-row-${c.id}`}>
            <div className="flex-1 min-w-[200px]">
              <div className="font-semibold">{c.name}</div>
              <div className="text-xs text-slate-500 font-mono">{[c.vat && `P.IVA ${c.vat}`, c.cf && `CF ${c.cf}`, c.sdi && `SDI ${c.sdi}`].filter(Boolean).join(" · ")}</div>
            </div>
            <div className="text-xs text-slate-500">{[c.city, c.province].filter(Boolean).join(" ")}</div>
            <button data-testid={`cassa-client-open-${c.id}`} onClick={() => setView(c.id)} className="press h-8 px-3 rounded-md bg-brand-navy text-white text-xs font-semibold flex items-center gap-1"><Eye className="w-3.5 h-3.5" /> Scheda</button>
            <button data-testid={`cassa-client-edit-${c.id}`} onClick={() => setEdit(c)} className="press h-8 px-3 rounded-md border text-xs font-semibold flex items-center gap-1"><Pencil className="w-3.5 h-3.5" /> Modifica</button>
            <ConfirmDelete small testId={`cassa-client-delete-${c.id}`} title={`Eliminare ${c.name}?`} text="L'anagrafica verrà cancellata. Le fatture già emesse restano invariate." onConfirm={() => del(c)} />
          </div>
        ))}
        {!list.length && <p className="p-5 text-sm text-slate-500">Nessun cliente.</p>}
      </div>
      <ClientDetail id={view} onClose={() => setView(null)} onEdit={(c) => { setView(null); setEdit(c); }} />
      <ClientForm client={edit} onClose={() => setEdit(null)} onSaved={(c) => { setEdit(null); load(); if (!edit?.id && c?.id) setView(c.id); }} />
    </div>
  );
}
